export default __webpack_public_path__ + "static/roland-fcd3519793bb3fd032f7a1f4b05d59d8.png";